import Vue from 'vue';
import Router from 'vue-router';
import beforeEach from './beforeEach.js';
import CntApp from '../components/cnt-app/index.vue';

import AppPerfis from '../components/settings/perfis/index.vue';
import AppUsers from '../components/settings/users/index.vue';
import AppLogin from '../components/login/index.vue';
import AppDashboard from '../components/dashboard/index.vue';

//Componentes de cadastros
import AppCadCat from '../components/cadastros/categorias/index.vue';
import AppCadastroCol from '../components/cadastros/colaboradores/index.vue';
import AppCadDep from '../components/cadastros/departments/index.vue';
import AppCadReg from '../components/cadastros/regions/index.vue';
import AppCadMan from '../components/cadastros/managers/index.vue';
import AppCadSel from '../components/cadastros/sellers/index.vue';
import AppCadCus from '../components/cadastros/customers/index.vue';
import AppCadTip from '../components/cadastros/types-of-proposals/index.vue';

import AppCadEx from '../components/cadastros/exames/index.vue';
import AppCadVc from '../components/cadastros/vacinas/index.vue';
import AppDashEx from '../components/exames_dashboard/index.vue';
import AppCadNavio from '../components/cadastros/navio/index.vue';
import AppCadTipoExame from '../components/cadastros/tipos_de_exame/index.vue';
import AppCadTipoVacina from '../components/cadastros/tipos_de_vacina/index.vue';
import AppCadResultadoExame from '../components/cadastros/resultados_exames/index.vue';
import AppCadastroStatusVacinacao from '../components/cadastros/status_vacinacao/index.vue';
import AppCadPassaport from '../components/cadastros/passaport/index.vue';
import AppCadCargExame from '../components/cadastros/cargos/index.vue';
import AppCadLocaldeExame from '../components/cadastros/local_de_exame/index.vue';

//Sistema
import AppServices from '../components/services/index.vue';
import sstSettings from '../components/app-settings/index.vue';
import sstContracts from '../components/contracts/index.vue';
import sstOrderOfService from '../components/order-of-service/index.vue';
import sstSupervisao from '../components/supervisao/index.vue';
import sstProposals from '../components/proposals/index.vue';
import sstOsStatics from '../components/settings/os-statics/index.vue';
// import AppSST from '../components/sst/index.vue'

//Componentes de modelos
import AppModTas from '../components/models/tasks/index.vue';
import AppModDocs from '../components/models/documents/index.vue';
import AppModelsForms from '../components/models/forms/index.vue';
import AppModelsCreateForms from '../components/models/create-form/index.vue';
import AppModelsTables from '../components/models/tables/table.vue';
import AppModelsTemplate from '../components/models/template/index.vue';

//SST...
import AppSSTSaude from '../components/sst/saude/index.vue';
import AppSSTSeguranca from '../components/sst/seguranca/index.vue';

// SD2000
import sd2000Solicitacoes from '../components/sd2000/solicitacoes/index.vue';
import sd2000Entradas from '../components/sd2000/entradas/index.vue';
import sd2000Extratos from '../components/sd2000/extratos/index.vue';
import sd2000Import from '../components/sd2000/import/index.vue';

import ContractActivation from '../components/contract-activation';

Vue.use(Router);

let router = new Router({
	routes: [
		{ path: '/contract-activation/:id', component: ContractActivation },
		{
			path: '/',
			component: CntApp,
			children: [
				// {path: 'sst', component: AppSST, name: 'AppSST'},
				{ path: 'perfis', component: AppPerfis, name: 'AppPerfis' },
				{
					path: 'dashboard',
					component: AppDashboard,
					name: 'AppDashboard',
				},
				{ path: 'categories', component: AppCadCat, name: 'AppCadCat' },
				{
					path: 'departments',
					component: AppCadDep,
					name: 'AppCadDep',
				},
				{ path: 'regions', component: AppCadReg, name: 'AppCadReg' },
				{ path: 'managers', component: AppCadMan, name: 'AppCadMan' },
				{
					path: 'collaborators',
					component: AppCadastroCol,
					name: 'AppCadastroCol',
				},
				{ path: 'sellers', component: AppCadSel, name: 'AppCadSel' },
				{ path: 'customers', component: AppCadCus, name: 'AppCadCus' },
				{
					path: 'types-of-proposals',
					component: AppCadTip,
					name: 'AppCadTip',
				},
				{ path: 'users', component: AppUsers, name: 'AppUsers' },
				{ path: 'tasks', component: AppModTas, name: 'AppModTas' },
				{
					path: 'services/:id',
					component: AppServices,
					name: 'AppServices',
				},
				{
					path: 'app-settings',
					component: sstSettings,
					name: 'sstSettings',
				},
				{
					path: 'contracts',
					component: sstContracts,
					name: 'sstContracts',
				},
				{
					path: 'order-of-service',
					component: sstOrderOfService,
					name: 'sstOrderOfService',
				},
				{
					path: 'supervisao',
					component: sstSupervisao,
					name: 'sstSupervisao',
				},

				{ path: 'exames', component: AppCadEx, name: 'AppCadEx' },
				{ path: 'vacinas', component: AppCadVc, name: 'AppCadVc' },
				{
					path: 'exames_dashboard',
					component: AppDashEx,
					name: 'AppDashEx',
				},
				{ path: 'navios', component: AppCadNavio, name: 'AppCadNavio' },

				{
					path: 'tipo_exame',
					component: AppCadTipoExame,
					name: 'AppCadTipoExame',
				},
				{
					path: 'tipo_vacina',
					component: AppCadTipoVacina,
					name: 'AppCadTipoVacina',
				},
				{
					path: 'status_vacinacao',
					component: AppCadastroStatusVacinacao,
					name: 'AppCadastroStatusVacinacao',
				},
				{
					path: 'passaporte',
					component: AppCadPassaport,
					name: 'AppCadPassaport',
				},
				{
					path: 'resultados',
					component: AppCadResultadoExame,
					name: 'AppCadResultadoExame',
				},
				//
				{
					path: 'cargo',
					component: AppCadCargExame,
					name: 'AppCadCargExame',
				},
				{
					path: 'local_exame',
					component: AppCadLocaldeExame,
					name: 'AppCadLocaldeExame',
				},

				{
					path: 'documents',
					component: AppModDocs,
					name: 'AppModDocs',
				},
				{
					path: 'forms',
					component: AppModelsForms,
					name: 'AppModelsForms',
				},
				{
					path: 'proposals',
					component: sstProposals,
					name: 'sstProposals',
				},
				{ path: 'create-forms', component: AppModelsCreateForms },
				{ path: 'edit-form/:cod', component: AppModelsCreateForms },
				{ path: 'tables/:id', component: AppModelsTables },
				{ path: 'new-template', component: AppModelsTemplate },
				{ path: 'os-statics', component: sstOsStatics },

				// SST
				{ path: 'sst/saude', component: AppSSTSaude },
				{ path: 'sst/seguranca', component: AppSSTSeguranca },

				// sd2000
				{ path: 'sd2000/import', component: sd2000Import },
				{ path: 'sd2000/solicitacoes', component: sd2000Solicitacoes },
				{ path: 'sd2000/entradas', component: sd2000Entradas },
				{ path: 'sd2000/extratos', component: sd2000Extratos },
			],
		},
		{ path: '/login', component: AppLogin, name: 'AppLogin' },
	],
});
router.beforeEach(beforeEach);
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js